export default __webpack_public_path__ + "static/media/video1.3171701b.mp4";